import React from "react";
import { IoMdRefresh, IoMdArrowBack } from "react-icons/io";

interface EmployeeHeaderProps {
  employeeName: string;
  loading: boolean;
  onBack?: () => void;
  onRefresh: () => void;
}

const EmployeeHeader: React.FC<EmployeeHeaderProps> = ({
  employeeName,
  loading,
  onBack,
  onRefresh,
}) => {
  return (
    <div className="employee-title-row">
      {onBack && (
        <button onClick={onBack} className="back-button-compact">
          {IoMdArrowBack({})}
        </button>
      )}
      <h1 className="employee-name">{employeeName}</h1>
      <button
        onClick={onRefresh}
        className="refresh-button-compact"
        disabled={loading}
        title="Daten aktualisieren"
      >
        {IoMdRefresh({})}
      </button>
    </div>
  );
};

export default EmployeeHeader;
